import React, { FunctionComponent } from "react";
import { Card as CardType } from "../../types";
import {makeStyles} from "@mui/styles";
import {Card, CardActions, CardActionArea, CardContent, Typography} from "@mui/material";

import ArrowLink from '../blockComponents/ArrowLink'

const useStyles = makeStyles({
  root: {
    maxWidth: 250,
  },
  media: {
      height: 140,
  },
});
interface Props {
  card?: CardType;
}
const ArticleCard: FunctionComponent<Props> = ({
  card: { title, slug, hero },
}) => {
  const classes = useStyles();
  return (
    <Card className={classes.root} variant="outlined">
      <CardActionArea href={slug}>
        <CardContent>
            <picture>
                <source
                  type="image/webp"
                  srcSet={`${hero.file.url}?fm=webp&w=216&q=80&h=140&fit=thumb`}
                  media="(max-width: 400px)"
                />
                <source
                  type="image/webp"
                  srcSet={`${hero.file.url}?fm=webp&w=216&q=80&h=140&fit=thumb`}
                  media="(min-width: 401px)"
                />
                <source
                  type="image/jpeg"
                  srcSet={`${hero.file.url}?w=216&q=80&h=140&fit=thumb`}
                  media="(max-width: 400px)"
                />
                <source
                  type="image/jpeg"
                  srcSet={`${hero.file.url}?w=216&q=80&h=140&fit=thumb`}
                  media="(min-width: 401px)"
                />
                <img
                  src={`${hero.file.url}?w=216&q=80&h=140&fit=thumb`}
                  alt={hero.title}
                  className={classes.media}
                  width="216"
                  height="140"
                />
              </picture>
        </CardContent>
        <CardContent>
          <Typography gutterBottom variant="h4" component="h3" align="left">
            {title}
          </Typography>
        </CardContent>
        <CardActions>
          <div style={{ flexGrow: 1 }} />
          <ArrowLink arrow="post">Read More</ArrowLink>
        </CardActions>
      </CardActionArea>
    </Card>
  );
};
export default ArticleCard;
